<template>
  <div>
    <button
      :style="{
        display: 'flex',
        width: '100%',
        placeContent: 'center',
        marginTop: '5px',
        marginBottom: '5px',
        color: corTexto,
        backgroundColor: corBotao,
      }"
      class="btn"
    >
      Esqueci minha senha
    </button>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 8px;
      "
    >
      <div v-if="choose">
        <h2 class="title cor-preta">Selecione forma de recuperação</h2>
        <div style="display: flex">
          <input type="radio" id="email" value="email" v-model="selected" />
          <label for="email" style="margin-left: 8px">Esqueci o email</label>
        </div>
        <div style="display: flex">
          <input
            type="radio"
            id="telefone"
            value="telefone"
            v-model="selected"
          />
          <label for="telefone" style="margin-left: 8px"
            >Esqueci o telefone</label
          >
        </div>
        <div
          style="margin-top: 8px"
          class="form-group"
          v-if="selected == 'telefone'"
        >
          <label for="exampleInputEmail1">Digite seu email</label>
          <input
            type="email"
            v-model="email"
            class="form-control"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Seu email"
          />
        </div>
        <div
          style="margin-top: 8px"
          class="form-group"
          v-if="selected == 'email'"
        >
          <label for="exampleInputTel1"
            >Digite o número do telefone(apenas números)</label
          >
          <input
            type="telefone"
            v-model="telefone"
            class="form-control"
            id="telefone"
            aria-describedby="telHelp"
            placeholder="Apenas Números"
          />
        </div>
        <button
          style="
            align-items: center;
            margin-bottom: 5px;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="identificar(email, telefone, selected)"
          v-if="selected == 'email' || selected == 'telefone'"
        >
          Continuar
        </button>
      </div>
      <div v-if="validate">
        <div v-if="selected == 'email'">
          <h2 class="title cor-preta">Digite seu email</h2>
          <p>{{ usuario.email.replace(/^(.{5})/, "*****") }}</p>
          <div class="form-group">
            <label for="exampleInputEmail1">Digite seu email</label>
            <input
              type="email"
              v-model="email"
              class="form-control"
              id="email"
              aria-describedby="emailHelp"
              placeholder="Seu email"
            />
          </div>
          <button
            style="align-items: center; background-color: #006400"
            class="btn btn-dark"
            @click="validar(usuario, email, telefone, selected)"
          >
            Validar email
          </button>
        </div>
        <div v-if="selected == 'telefone'">
          <h2 class="title cor-preta">Complete seu telefone</h2>
          <p>{{ usuario.fone.replace(/(\d{4})$/, "****") }}</p>
          <div style="margin-top: 8px">
            <label for="exampleInputTel1"
              >Digite os ultimos 4 digitos(apenas números)</label
            >
            <input
              type="telefone"
              v-model="digitos"
              class="form-control"
              id="telefone"
              aria-describedby="telHelp"
              placeholder="Apenas Números"
            />
          </div>
          <button
            style="
              align-items: center;
              background-color: #006400;
              margin-top: 8px;
            "
            class="btn btn-dark"
            @click="validar(usuario, email, digitos, selected)"
          >
            Validar telefone
          </button>
        </div>
      </div>
      <div v-if="replace">
        <div class="form-group">
          <label for="exampleInputPassword1">Senha nova</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Senha"
            v-model="senhaNova"
          />
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Confirmar senha nova</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword2"
            placeholder="Senha"
            v-model="senhaConfirmar"
          />
        </div>
        <button
          style="align-items: center; background-color: #006400"
          class="btn btn-dark"
          @click="alterarSenha(senhaNova, senhaConfirmar)"
        >
          Alterar
        </button>
      </div>
    </div>
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
.custom-datetime {
  padding: 10px;
  border: 2px solid #545454; /* Borda azul */
  border-radius: 5px; /* Arredondar os cantos */
  font-size: 16px; /* Tamanho da fonte */
  color: #545454; /* Cor do texto */
  background-color: #f0f0f0; /* Fundo mais claro */
  transition: border-color 0.3s, box-shadow 0.3s; /* Suavizar a transição de borda e sombra */
}

.custom-datetime:focus {
  border-color: #545454; /* Borda azul mais escura ao focar */
  box-shadow: 0 0 5px rgba(84, 84, 84, 0.5); /* Sombra ao focar */
  outline: none; /* Remover contorno padrão */
}

.custom-datetime::-webkit-calendar-picker-indicator {
  background-color: #f0f0f0; /* Cor do ícone do calendário */
  padding: 5px;
  border-radius: 50%;
}
</style>
<script>
import Swal from "sweetalert2";
import Usuario from "../services/usuario";
import Inis from "../services/inis";

export default {
  name: "AlterarSenha",
  data() {
    return {
      senha: "",
      senhaNova: "",
      senhaConfirmar: "",
      alterar: false,
      validaTelefone: "",
      corFundo: "",
      corBotao: "",
      corTexto: "",
      email: "",
      telefone: "",
      selected: "",
      choose: true,
      validate: false,
      replace: false,
      usuario: {
        email: "",
        fone: "",
      },
      digitos: "",
    };
  },
  methods: {
    pushSair() {
      this.$router.push("/login");
    },
    listandoInis() {
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
    },
    validarTelefone(telefone) {
      var apenasNumeros = telefone.replace(/\D/g, "");
      return apenasNumeros.length >= 10 && apenasNumeros.length <= 11;
    },
    validarEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    async identificar(email, telefone, selected) {
      if (!this.validarTelefone(telefone) && selected == "email") {
        Swal.fire({
          title: "Telefone inválido",
          confirmButtonColor: "#000000",
        });
        return;
      }
      if (!this.validarEmail(email) && selected == "telefone") {
        Swal.fire({
          title: "Email inválido",
          confirmButtonColor: "#000000",
        });
        return;
      }
      if (selected === "email") {
        var usuario = await Usuario.getByFone(telefone);
        if (usuario.data == null) {
          Swal.fire({
            title: "Telefone não encontrado",
            confirmButtonColor: "#000000",
          });
          return;
        }
        this.usuario = usuario.data[0];
      } else if (selected === "telefone") {
        var usuario = await Usuario.getByEmail(email);
        if (usuario.data == null) {
          Swal.fire({
            title: "Email não encontrado",
            confirmButtonColor: "#000000",
          });
          return;
        }
        this.usuario = usuario.data[0];
      }

      if (this.usuario.email == null) {
        const { value: email } = await Swal.fire({
          title: "Insira seu email",
          input: "email",
          inputLabel: "Seu endereço de email",
          inputPlaceholder: "Insira seu endereço de email",
        });
        if (email) {
          this.email = email;
          this.choose = false;
          this.replace = true;
        } else {
          Swal.fire({
            title: "Ocorreu um erro",
            confirmButtonColor: "#000000",
          });
          return;
        }
      }else{
          this.choose = false;
          this.validate = true;
      }

    },
    validar(usuario, email, telefone, selected) {
      if (selected == "email") {
        if (usuario.email == email) {
          this.validate = false;
          this.replace = true;
        } else {
          Swal.fire({
            title: "Erro, emails diferentes",
            confirmButtonColor: "#000000",
          });
        }
      } else if (selected == "telefone") {
        if (usuario.fone.slice(-4) == telefone) {
          this.validate = false;
          this.replace = true;
        } else {
          Swal.fire({
            title: "Erro, telefones diferentes",
            confirmButtonColor: "#000000",
          });
        }
      }
    },
    async alterarSenha(senhaNova, senhaConfirmar) {
      if (senhaNova == senhaConfirmar) {
        var usuario = new Object();

        usuario.email_new = this.email;
        usuario.telefone = this.telefone;

        await Usuario.alterarusuario(usuario);

        var usuario = new Object();

        usuario.email = this.email;
        usuario.senhaNova = senhaNova;

        await Usuario.alterarsenha(usuario).then((resposta) => {
          Swal.fire({
            title: resposta.data,
            confirmButtonColor: "#000000",
          });
        });
        this.$router.push("/login");
      } else {
        Swal.fire({
          title: "Senhas precisam ser iguais",
          confirmButtonColor: "#000000",
        });
      }
    },
  },
  mounted() {
    this.listandoInis();
  },
};
</script>